import { waitingResponseSlice } from '@patrianna/shared-store'
import { authSlice } from '@patrianna/shared-store/auth/store/slice'
import { paymentsSlice } from '@patrianna-payments/shared-store/payments/store/slice'
import { redeemSlice } from '@patrianna-payments/shared-store/redeem/store/slice'
import { skipOtpSlice } from '@patrianna-payments/shared-store/skip-otp/store/slice'
import { verificationsSlice } from '@patrianna-payments/shared-store/verifications/store/slice'
import { locationVerificationSlice } from '@patrianna-ui-features/location-verification'

import { brandConfigSlice } from 'store/modules/brandConfig/slice'
import { favoritesSlice } from 'store/modules/favorites/slice'
import { jackpotsFromProvidersSlice } from 'store/modules/jackpotsFromProviders/slice'

import { appConfigSlice } from './appConfig/slice'
import { bannerSlice } from './banners/slice'
import { bingoSlice } from './bingo/slice'
import { bonusesFlowSlice } from './bonusesFlow/slice'
import { cookieConsentSlice } from './cookieConsent/slice'
import { currenciesSlice } from './currencies/slice'
import { gamesSlice } from './games/slice'
import { jackpotsSlice } from './jackpots/slice'
import { kycSlice } from './kyc/slice'
import { phoneVerificationSlice } from './phoneVerification/slice'
import { playedGamesSlice } from './playedGames/slice'
import { prerequisitesSlice } from './prerequisites/slice'
import { shopSlice } from './shop/slice'
import { slotGameFlowSlice } from './slotGameFlow/slice'
import { snackbarSlice } from './snackbar/slice'
import { uiSlice } from './ui/slice'
import { userSlice } from './user/slice'

// import { appConfigSlice, ActionsTypes as AppActions } from './appConfig/slice'
// import { snackbarSlice, ActionsTypes as SnackActions } from './snackbar/slice'
// import type { CurrenciesSlice, ActionsTypes as CurrenciesActions } from './currencies/slice'
// import { userSlice, ActionsTypes as UserActions } from './user/slice'
// import { gamesSlice, ActionsTypes as GamesActions } from './games/slice'
// import { playedGamesSlice, ActionsTypes as PlayedGamesActions } from './playedGames/slice'
// import { prerequisitesSlice, ActionsTypes as PrerequisitesActions } from './prerequisites/slice'
// import { shopSlice, ActionsTypes as ShopActions } from './shop/slice'
// import { slotGameFlowSlice, ActionsTypes as SlotGameActions } from './slotGameFlow/slice'
// import { authSlice, ActionsTypes as AuthActions } from './auth/slice'
// import { redeemSlice, ActionsTypes as RedeemFlowActions } from './redeem/slice'
// import { paymentsFlowSlice, ActionsTypes as PaymentsActions } from './paymentsFlow/slice'
// import { bonusesFlowSlice, ActionsTypes as BonusesActions } from './bonusesFlow/slice'
// import { phoneVerificationSlice, ActionsTypes as PhoneVerificationActions } from './phoneVerification/slice'

const staticReducers = {
  appConfig: appConfigSlice.reducer,
  kyc: kycSlice.reducer,
  ui: uiSlice.reducer,
  snackbar: snackbarSlice.reducer,
  currencies: currenciesSlice.reducer,
  user: userSlice.reducer,
  games: gamesSlice.reducer,
  playedGames: playedGamesSlice.reducer,
  favorites: favoritesSlice.reducer,
  prerequisites: prerequisitesSlice.reducer,
  shop: shopSlice.reducer,
  slotGameFlow: slotGameFlowSlice.reducer,
  bonusesFlow: bonusesFlowSlice.reducer,
  phoneVerification: phoneVerificationSlice.reducer,
  jackpots: jackpotsSlice.reducer,
  banners: bannerSlice.reducer,
  cookieConsent: cookieConsentSlice.reducer,
  brandConfig: brandConfigSlice.reducer,
  ...(process.env.BRAND === 'pulszbingo' ? { bingo: bingoSlice.reducer } : {}),
  [skipOtpSlice.name]: skipOtpSlice.reducer,
  [verificationsSlice.name]: verificationsSlice.reducer,
  [redeemSlice.name]: redeemSlice.reducer,
  [paymentsSlice.name]: paymentsSlice.reducer,
  auth: authSlice.reducer,
  waitingResponse: waitingResponseSlice.reducer,
  [jackpotsFromProvidersSlice.name]: jackpotsFromProvidersSlice.reducer,
  [locationVerificationSlice.name]: locationVerificationSlice.reducer,
}

export default staticReducers
